import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { exportTemplate, extraButtonFunction, filterIconBackgroundColor, isColumnChecked, onlyVisibleItems, onlyVisibleItemsNoImages, selectedIncomingValue, validationHeaderButtonsFunc, viewDefaultButtonBackgroundColor, viewDefaultButtonBorderColor, viewDefaultButtonLabelColor, viewFilterButtonBackgroundColor, viewFilterButtonBorderColor, viewFilterButtonLabelColor, worksheetSelectColumns } from './TableServices'
import { MButton, MInputTextField, MSwitchButton, AdvanceFilter, BufferService, FiltersSortService, LoadingContext } from '../../M_Components'
import { Badge, InputAdornment, InputBase, Menu, MenuItem, useMediaQuery } from '@mui/material'
import { AddCircleOutlineOutlined, Close, FilterAltOutlined, PushPinOutlined, Search, VisibilityOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import * as XLSX from "xlsx"
import * as Excel from "exceljs"
import { saveAs } from 'file-saver'

export function TableHeader({ colorOptions, views, selectedView,
    metaType, setMetaPair, metaPair, allColumns, color,
    removeColumns, removeFilters, filtersOnTable, changeView, onColumnToggle,
    selectedColumns, filteredColumnModal, valueFilteredColumnModal,
    globalFilterValue, globalSearch, inputFilter, value, selectedRows,
    newButtons, entity, includeTemplateExcel, permissions, includeImportExcel,
    removeItem, isCrud, setLoading, replaceFunctions, setAdvFilterString, columns,
    handleOpenDialogAdd, handleOpenDelete, handleOpenCopy, handleOpenEdit,
    setFilteredColumnModal, setValueFilteredColumnModal, getWithFilters, setSelectedRows,
    setSelectedView, get, setViews, setExpandedRows, groupField, setIsLoaded,
    setRows, setTotalRows, valueIdField, bufferService, FILTER, orderInfo, pageSize,
    page

}) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    const maxWidth = useMediaQuery('(min-width:1050px)')
    const mobileWidth = useMediaQuery('(min-width:500px)')
    const compactWidth = useMediaQuery('(max-width:500px)')

    const filterService = new FiltersSortService()
    const bufferImportService = new BufferService(`${entity}/Import`)
    const bufferExportService = new BufferService(`${entity}/ExportData`)

    const [anchorAF, setAnchorAF] = useState(null)
    const [anchorEls, setAnchorEls] = useState(null)
    const [anchorEl, setAnchorEl] = useState(null)
    const [anchorV, setAnchorV] = useState(null)

    const openMenuPrint = Boolean(anchorEl);
    const openMenuHideColumns = Boolean(anchorEls)
    const openMenuViews = Boolean(anchorV)

    /**
     * Controls when header action labels should be visible.
     *
     * Purpose:
     * - wide screens show full text labels next to each icon;
     * - compact screens keep labels visible with smaller typography;
     * - intermediate widths keep icon-only actions to avoid horizontal overflow.
     */
    const showHeaderButtonLabels = maxWidth || compactWidth

    /**
     * Resolves the icon size used by table header actions.
     *
     * Purpose:
     * - compact screens use smaller icons so the action rows can occupy the full width cleanly;
     * - other narrow screens keep the icon-only layout with a moderate icon size;
     * - wide screens keep the default icon size.
     */
    const mobileResize = compactWidth ? '1rem' : (!mobileWidth ? '1.3rem' : undefined)

    /**
     * Resolves the visible text for table header action buttons.
     *
     * @param {string} labelKey - Translation key used for static button labels.
     * @param {string} fallbackLabel - Optional dynamic label already resolved by the caller.
     * @returns {string} Button label for the current responsive mode.
     */
    const headerButtonLabel = (labelKey, fallbackLabel) => {
        if (!showHeaderButtonLabels) return ''
        return fallbackLabel || t(labelKey)
    }

    //*open export menu
    const handleClickOpenMenuPrint = (event) => {
        setAnchorEl(event.currentTarget)
    }

    //*close export menu
    const handleCloseMenuPrint = () => {
        setAnchorEl(null);
    }

    //*open menu show hide
    const handleClickOpenMenuHideColumns = (event) => {
        setAnchorEls(event.currentTarget)
    }

    //*close menu show/hide
    const handleCloseMenuHideColumns = () => {
        setAnchorEls(null)
    }

    const handleClickOpenViews = (event) => {
        setAnchorV(event.currentTarget)
    }

    const handleClickCloseViews = () => {
        setAnchorV(null)
    }

    const handleOpenAdvancedFilterMenu = (event) => {
        setAnchorAF(event.currentTarget)
    }

    const addMetaPair = (filter) => {
        let tempBol = false
        if (metaPair.length) {
            metaPair.forEach((element) => {
                //* checking if it exists
                if (element.name === filter.name) {
                    tempBol = true
                }
            })
            if (tempBol === true) {
                //* editing if it already exists
                setMetaPair(metaPair.map((elem) => elem.name === filter.name ? { ...elem, operation: filter.operation, value: filter.value } : elem))
            }
            else {
                //* creating new if it doesnt exist
                setMetaPair(prev => [...prev, filter])
            }
        }
        else {
            //* creating if array empty
            setMetaPair([filter])
        }
    }

    const saveFilter = (newView) => {
        setLoading(true)
        let url = filterService.advancedSearch(metaPair, true)
        setAdvFilterString(url)
        if (orderInfo.columnName) {
            url = filterService.orderBy(orderInfo, url)
        }
        const tempPageString = filterService.pagination(page, pageSize)
        url = tempPageString.concat(url)

        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, metaPair, FILTER)

        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }
            selectedIncomingValue(res, value, valueIdField, selectedRows, setSelectedRows)
            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
        })
        setViews(new Map(views.set(newView, url)))
        setSelectedView(newView)
    }

    //*submit filters
    const submitFilters = (input, order) => {
        setLoading(true)
        const data = input || metaPair
        const passOrder = order || orderInfo

        let url = filterService.queryBuilder(page, pageSize, passOrder, data, FILTER)

        bufferService.filter(url).then(res => {
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res, value, valueIdField, selectedRows, setSelectedRows)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })
        return url
    }



    //*clear all advanced filters
    const deleteAllFilters = () => {
        setLoading(true)
        setAdvFilterString('')
        setMetaPair([])
        const newUrl = filterService.queryBuilder(page, pageSize, orderInfo, undefined, FILTER)

        bufferService.filter(newUrl).then(res => {
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.message, '')
                setRows([])
                setTotalRows([])
                setLoading(false)
                setIsLoaded(false)
                return
            }

            selectedIncomingValue(res, value, valueIdField, selectedRows, setSelectedRows)

            setTotalRows(res.TotalItems)
            setRows(res.Items)
            setLoading(false)
            setIsLoaded(false)
            if (groupField) {
                setExpandedRows(res.Items)
            }
        })

    }

    //*delete advanced filters individually
    const deleteFilter = (filterName) => {
        const tempMeta = metaPair.filter(elem => elem.name !== filterName)
        setMetaPair(tempMeta)
        submitFilters(tempMeta)
    }

    const deleteView = (name) => {
        views.delete(name)
        setViews(new Map(views))
        if (selectedView === name) {
            setSelectedView('')
        }
    }

    const createView = (e) => {
        get(allColumns)
        setMetaPair([])
        setSelectedView('')
        handleClickCloseViews()
        setAnchorAF(document.getElementById('advFilter'))
    }

    //*table refresh / was refresh of all filters and sort
    const clear = () => {
        getWithFilters()
        setSelectedRows([])
        ctx.toastMessages('success', '', t("RefreshTable"))
    }

    //* Export Excel
    const exportExcel = () => {
        if (selectedRows.length === 0) {
            bufferExportService.get().then(res => {
                if (res.name === 'AxiosError') {
                    ctx.toastMessages("error", t("DataLoadError"), '')
                }
                else {
                    createWorksheet(res)
                }
            })
        } else {
            createWorksheet(selectedRows)
        }
    }

    function createWorksheet(data) {
        const tempRows = onlyVisibleItems(data, selectedColumns)
        const tempRowsNoImg = onlyVisibleItemsNoImages(data, selectedColumns)
        let workbook = new Excel.Workbook()
        const worksheet = workbook.addWorksheet(entity)
        const tempCol = selectedColumns.map(col => {
            const temp = {
                header: col.NormalizedName,
                key: col.Name
            }
            return temp
        })
        worksheet.columns = tempCol
        worksheet.addRows(tempRowsNoImg)
        tempRows.forEach((row, index) => {
            Object.entries(row).forEach(([key]) => {
                workbook = worksheetSelectColumns(workbook, worksheet, key, index, selectedColumns, value)
            })
        })
        workbook.xlsx.writeBuffer().then(data => {
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const blob = new Blob([data], { type: fileType })
            saveAs(blob, `${entity}.xlsx`)
            handleCloseMenuPrint()
            ctx.toastMessages('success', '', t("ExportSuccess"))
        })
    }

    const importExcel = (e) => {
        ctx.setIsLoad(true)
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append("file", file)
        bufferImportService.post(formData).then(resObj => {
            ctx.setIsLoad(false)
            if (resObj.name === 'AxiosError') {
                ctx.toastMessages('error', resObj.response.data, '')
                return
            }
            ctx.toastMessages('success', '', resObj)
            getWithFilters()
        })
        handleCloseMenuPrint()
    }

    //* search on show/hide columns
    const filterColumnModal = (data) => {
        setValueFilteredColumnModal(data)
        const regex = new RegExp(data)
        const tempElem = columns.filter((elem) => regex.test(elem.NormalizedName))
        setFilteredColumnModal(tempElem)
    }

    function headerCrudButtons(operation) {
        if (validationHeaderButtonsFunc(operation, removeItem, permissions)) {
            switch (operation) {
                case 'Create':
                    return (
                        <MButton
                            marginNone={!maxWidth}
                            tooltip={t("Add")}
                            label={headerButtonLabel("Add")}
                            icon={<AddCircleOutlineOutlined style={{ color: 'var(--color-green-light)', fontSize: mobileResize }} />}
                            onClick={onClickHeaderFunc('Create')}
                        />)
                case 'Edit':
                    return (
                        <MButton
                            marginNone={!maxWidth}
                            tooltip={t("Edit")}
                            label={headerButtonLabel("Edit")}
                            icon={<i className='pi pi-pencil iconTable' style={{ fontSize: mobileResize }}></i>}
                            onClick={onClickHeaderFunc('Edit')}
                        />)
                case 'Delete':
                    return (
                        <MButton
                            marginNone={!maxWidth}
                            tooltip={t("Delete")}
                            label={headerButtonLabel("Delete")}
                            icon={<i className='pi pi-trash iconTable' style={{ fontSize: mobileResize }}></i>}
                            onClick={onClickHeaderFunc('Delete')}
                        />)
                case 'Copy':
                    return (
                        <MButton
                            marginNone={!maxWidth}
                            tooltip={t("Copy")}
                            label={headerButtonLabel("Copy")}
                            icon={<i className='pi pi-copy iconTable' style={{ fontSize: mobileResize }}></i>}
                            onClick={onClickHeaderFunc('Copy')}
                        />)
                default: break
            }
        }
    }

    function onClickHeaderFunc(operation) {
        switch (operation) {
            case 'Create':
                return replaceFunctions?.get(operation) ? () => replaceFunctions?.get('Create')() : () => handlerPicker(operation)
            case 'Edit':
            case 'Copy':
                return replaceFunctions?.get(operation) ? () => replaceFunctions?.get(operation)(selectedRows[selectedRows.length - 1]) : () => handlerPicker(operation)
            case 'Delete':
                return replaceFunctions?.get(operation) ? () => replaceFunctions?.get('Delete')(selectedRows) : () => handlerPicker(operation)
            default: break
        }
    }

    function handlerPicker(operation) {
        switch (operation) {
            case 'Create': return handleOpenDialogAdd()
            case 'Edit': return handleOpenEdit(selectedRows[selectedRows.length - 1])
            case 'Copy': return handleOpenCopy(selectedRows[selectedRows.length - 1])
            case 'Delete': return handleOpenDelete(selectedRows)
            default: break
        }
    }

    function headerButtons() {
        if (isCrud) {
            return (
                <>
                    {!removeItem.includes('Print') ?
                        <MButton
                            marginNone={!maxWidth}
                            tooltip={t("Print")}
                            label={headerButtonLabel("Print")}
                            icon={<i className='pi pi-print' style={{ fontSize: mobileResize }}></i>}
                            onClick={handleClickOpenMenuPrint}
                        />
                        : <></>
                    }
                    <Menu
                        anchorEl={anchorEl}
                        open={openMenuPrint}
                        onClose={handleCloseMenuPrint}
                        className="menuExcel"
                    >
                        {permissions.includes('Create') && includeImportExcel ?
                            <MenuItem className='menuItem'>
                                <input
                                    className='importExcel'
                                    type="file"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    onChange={importExcel}
                                />
                                {t("ImportExcel")}
                            </MenuItem>
                            : null
                        }
                        {permissions.includes('Create') && includeTemplateExcel ?
                            <MenuItem className='menuItem' onClick={() => exportTemplate(metaType, XLSX, entity)}>
                                {t("Template")}
                            </MenuItem>

                            : null
                        }
                        <MenuItem className='menuItem' onClick={exportExcel}>
                            {t("ExportExcel")}
                        </MenuItem>
                    </Menu>
                    {headerCrudButtons('Create')}
                    {headerCrudButtons('Edit')}
                    {headerCrudButtons('Delete')}
                    {headerCrudButtons('Copy')}
                </>
            )
        }
        return null
    }

    return (
        <div className="display header">
            <div className="menuIcon">
                {/* {console.log(mobileWidth)} */}
                <MButton
                    marginNone={!maxWidth}
                    tooltip={t("RefreshTable")}
                    label={headerButtonLabel("RefreshTable")}
                    icon={<i className='pi pi-refresh' style={{ fontSize: mobileResize }}></i>}
                    onClick={() => clear()}
                />
                {headerButtons()}
                {newButtons.map((btn, index) =>
                    btn.element === 'default' ?
                        <React.Fragment key={btn?.label || index}>
                            <MButton
                                marginNone={!maxWidth}
                                tooltip={btn.label}
                                label={headerButtonLabel("", btn?.label)}
                                icon={btn?.icon ? btn?.icon : <img style={btn.style} src={btn.source} alt={btn.label} className="iconTable" />}
                                onClick={() => extraButtonFunction(selectedRows[selectedRows.length - 1], btn.command, btn?.needLine, ctx.toastMessages, t, selectedRows, value)}
                            />
                            {btn.extraEl !== null ?
                                btn.extraEl
                                : null}
                        </React.Fragment>
                        : btn.element
                )}
            </div>
            {inputFilter && !filtersOnTable && <div className="menuSearch" style={{ right: '10px' }}>
                <MInputTextField
                    iconEnd={<Search onClick={() => globalSearch(globalFilterValue)} style={{ color: ctx.primaryColor, cursor: 'pointer' }} />}
                    noAutoShrink
                    label={t('Search')}
                    value={globalFilterValue}
                    onChange={(event) => globalSearch(event.target.value)}
                    autoFocus
                    onEnter={() => globalSearch(globalFilterValue)}
                />
            </div>}
            {filtersOnTable && <div className="menuSearch">
                {inputFilter && <div style={{ marginRight: '10px' }}>
                    <MInputTextField
                        iconEnd={<Search onClick={() => globalSearch(globalFilterValue)} style={{ color: ctx.primaryColor, cursor: 'pointer' }} />}
                        noAutoShrink
                        label={t('Search')}
                        value={globalFilterValue}
                        onChange={(event) => globalSearch(event.target.value)}
                        autoFocus
                        onEnter={() => globalSearch(globalFilterValue)}
                    />
                </div>}
                <MButton
                    marginNone={!maxWidth}
                    tooltip={t("Views")}
                    label={headerButtonLabel("Views")}
                    icon={<PushPinOutlined style={{ transform: 'rotate(45deg)', fontSize: mobileResize }} />}
                    onClick={handleClickOpenViews}
                />
                <MButton
                    marginNone={!maxWidth}
                    id={'advFilter'}
                    tooltip={t("Filters")}
                    label={headerButtonLabel("Filters")}
                    icon={
                        <Badge
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            badgeContent={metaPair.length}
                            sx={{
                                "& .MuiBadge-badge": {
                                    color: "var(--color-white)",
                                    backgroundColor: filterIconBackgroundColor(color)
                                }
                            }} >
                            <FilterAltOutlined
                                sx={{ height: !mobileResize && '30px' }}
                                style={{ fontSize: mobileResize }}
                            />
                        </Badge>
                    }
                    onClick={handleOpenAdvancedFilterMenu}
                />
                <MButton
                    marginNone={!maxWidth}
                    tooltip={t("editColumns")}
                    label={headerButtonLabel("editColumns")}
                    icon={<VisibilityOutlined sx={{ height: !mobileResize && '30px' }} style={{ fontSize: mobileResize }} />}
                    onClick={handleClickOpenMenuHideColumns}
                />
                <Menu
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    anchorEl={anchorEls}
                    open={openMenuHideColumns}
                    onClose={handleCloseMenuHideColumns}
                    className="organizeMenuSearchTable"
                    MenuListProps={{ disablePadding: true }}
                >
                    <div className='stickyTopTable'>
                        <MenuItem disableRipple={true} className="organizeMenuItem" >
                            <InputBase
                                onChange={(e) => { filterColumnModal(e.target.value) }}
                                placeholder={t("Search")}
                                className='organizeInputBase'
                                inputProps={{ 'aria-label': 'Search Columns' }}
                                value={valueFilteredColumnModal}
                                startAdornment={
                                    <InputAdornment position="start"> <Search /> </InputAdornment>
                                }
                            />
                        </MenuItem>
                    </div>
                    {filteredColumnModal.map((col, index) => (
                        <div className='menuSwtchs menuItem' key={col?.name || index}>
                            <MSwitchButton label={col.NormalizedName} color={color || "var(--color-black)"} checked={isColumnChecked(col.name, selectedColumns)} onClick={(event) => onColumnToggle(col, event)} labelColor={"var(--color-black)"} />
                        </div>
                    ))}
                </Menu>
                <Menu
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                    anchorEl={anchorV}
                    open={openMenuViews}
                    onClose={handleClickCloseViews}
                    className="menuViews"
                    MenuListProps={{ disablePadding: true }}
                >
                    <div className='stickyTop center' style={{ borderBottom: '1px solid var(--color-grey-light)', marginBottom: '5px' }}>
                        <MButton
                            width={30}
                            hoverEffect
                            label={t("LabelDefaultView")}
                            borderColor={viewDefaultButtonBorderColor(selectedView, color)}
                            backgroundColor={viewDefaultButtonBackgroundColor(selectedView, color)}
                            labelColor={viewDefaultButtonLabelColor(selectedView, color)}
                            onClick={() => changeView('Default')}
                        />
                    </div>
                    {Object.keys(Object.fromEntries(views)).map((col, index) => (
                        <div className='midleViews menuitem' key={col || index}>
                            {col !== 'Default' ?
                                <>
                                    <MButton
                                        width={60}
                                        hoverEffect
                                        label={col}
                                        borderColor={viewFilterButtonBorderColor(col, selectedView, color)}
                                        backgroundColor={viewFilterButtonBackgroundColor(col, selectedView, color)}
                                        labelColor={viewFilterButtonLabelColor(col, selectedView, color)}
                                        onClick={() => changeView(col)}
                                    />
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <MButton
                                            height={5}
                                            width={3}
                                            marginNone
                                            hoverEffect
                                            icon={<Close style={{ color: 'var(--color-red)' }} />}
                                            onClick={() => deleteView(col)}
                                        />
                                    </div>
                                </>
                                : ''
                            }
                        </div>
                    ))}
                    <div className='stickyBot center'>
                        <MButton
                            icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            hoverEffect
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={(e) => createView(e)}
                            label={`${t('CreateNewView')}`}
                            width={25}
                        />
                    </div>
                </Menu>
            </div>}

            {filtersOnTable ? <div>
                <AdvanceFilter
                    removeFilters={removeFilters}
                    removeColumns={removeColumns}
                    color={color || "var(--color-black)"}
                    onDeleteFilter={deleteFilter}
                    onDeleteAllFilters={deleteAllFilters}
                    onSubmitFilters={submitFilters}
                    onAddMetaPair={addMetaPair}
                    metaPair={metaPair}
                    metaType={metaType}
                    anchorAF={anchorAF}
                    setAnchorAF={setAnchorAF}
                    onSaveFilter={saveFilter}
                    selectedView={selectedView}
                    views={views}
                    onToasts={(type, alert, string) => ctx.toastMessages(type, alert, string)}
                    colorOptions={colorOptions}
                />
            </div> : ""}
        </div>
    )
}

TableHeader.propTypes = {
    colorOptions: PropTypes.object,
    views: PropTypes.object,
    selectedView: PropTypes.string,
    metaType: PropTypes.array,
    setMetaPair: PropTypes.func,
    metaPair: PropTypes.array,
    allColumns: PropTypes.array,
    color: PropTypes.string,
    removeColumns: PropTypes.array,
    removeFilters: PropTypes.array,
    filtersOnTable: PropTypes.bool,
    changeView: PropTypes.func,
    onColumnToggle: PropTypes.func,
    selectedColumns: PropTypes.array,
    filteredColumnModal: PropTypes.array,
    valueFilteredColumnModal: PropTypes.string,
    globalFilterValue: PropTypes.string,
    globalSearch: PropTypes.func,
    inputFilter: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string,
    ]),
    selectedRows: PropTypes.array,
    newButtons: PropTypes.array,
    entity: PropTypes.string,
    includeTemplateExcel: PropTypes.bool,
    permissions: PropTypes.array,
    includeImportExcel: PropTypes.bool,
    removeItem: PropTypes.array,
    isCrud: PropTypes.bool,
    setLoading: PropTypes.func,
    replaceFunctions: PropTypes.object,
    setAdvFilterString: PropTypes.func,
    columns: PropTypes.array,
    handleOpenDialogAdd: PropTypes.func,
    handleOpenDelete: PropTypes.func,
    handleOpenCopy: PropTypes.func,
    handleOpenEdit: PropTypes.func,
    setFilteredColumnModal: PropTypes.func,
    setValueFilteredColumnModal: PropTypes.func,
    getWithFilters: PropTypes.func,
    setSelectedRows: PropTypes.func,
    setSelectedView: PropTypes.func,
    get: PropTypes.func,
    setViews: PropTypes.func,
    setExpandedRows: PropTypes.func,
    groupField: PropTypes.array,
    setIsLoaded: PropTypes.func,
    setRows: PropTypes.func,
    setTotalRows: PropTypes.func,
    valueIdField: PropTypes.string,
    bufferService: PropTypes.object,
    FILTER: PropTypes.string,
    orderInfo: PropTypes.object,
    pageSize: PropTypes.number,
    page: PropTypes.number
}
